import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa-duotone fa-magnifying-glass" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!

  return (_openBlock(), _createBlock(_component_n_form_item, {
    rule: {
      required: $props.required,
      message: $props.message,
      trigger: ['input', 'blur'],
    },
    label: $props.label,
    class: _normalizeClass('col-md-' + $props.col + '  mb-' + $props.mb),
    path: $props.path,
    "show-label": $props.ShowLabel,
    "require-mark-placement": "right-hanging",
    "show-require-mark": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_input, {
        clearable: "",
        value: $setup.MyValue,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.MyValue) = $event)),
        size: "medium",
        disabled: $props.disabled,
        placeholder: $props.placeholder
      }, {
        prefix: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["value", "disabled", "placeholder"])
    ]),
    _: 1
  }, 8, ["rule", "label", "class", "path", "show-label"]))
}